import { render, staticRenderFns } from "./DocumentSeriesTypeListFilter.vue?vue&type=template&id=1127fd07&"
import script from "./DocumentSeriesTypeListFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesTypeListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports